import React from 'react';
import PropTypes from 'prop-types';

import {
  ErrorMessage,
} from 'formik';
import { InputFormField } from '@playbookux/playbook-web-core';

import {
  Title,
  Text,
  Input,
  BottomContainer,
  Button,
  Error,
} from '../styles';

const ForgotPasswordForm = (props) => {
  const {
    submitError,
    onSubmit,
    loading,
  } = props;

  return (
    <>
      <Title>Forgot your password?</Title>

      <Text>Don&apos;t worry, we&apos;ll send you an email to reset it.</Text>

      <Input
        fluid
        component={InputFormField}
        placeholder="Email address"
        name="email"
      />
      <ErrorMessage component={Error} name="email" />
      {submitError && (
        <Error component={Error}>{submitError}</Error>
      )}

      <BottomContainer>
        <Button
          type="submit"
          onClick={onSubmit}
          loading={loading}
        >
          Continue
        </Button>
      </BottomContainer>
    </>
  );
};

ForgotPasswordForm.propTypes = {
  loading: PropTypes.bool,
  submitError: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
};

ForgotPasswordForm.defaultProps = {
  loading: false,
  submitError: '',
};

export default ForgotPasswordForm;
